import React, { useEffect} from 'react';
import NewLandingPageIndex from '../../components/NewLandingPage/NewLandingPageIndex';
import TagManager from 'react-gtm-module';


const NewLandingPage = () => {

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: 'GTM-NHT6WQS'
    }
    TagManager.initialize(tagManagerArgs);
  }, []); 

  return (
    <>    
      <NewLandingPageIndex/>    
    </>
  )
}

export default NewLandingPage;
